import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment.testing';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {apiEndpoints} from '../app.constants';

declare var require: any;

@Injectable()
export class MockBaseService {
  private env = environment;
  private mockResponses = new Map();
  constructor() {
    this.env = environment;
  }

  private getMockResponse(url) {
    return this.mockResponses.get(url);
  }

  public setResponse(url, res) {
    this.mockResponses.set(url, res);
  }

  get(url, options = {}): Observable<any> {
    return Observable.of(this.getMockResponse(url));
  }

  post(url, postData: any, options = {}): Observable<any> {
    return Observable.of(this.getMockResponse(url));
  }

  put(url, postData: any, options = {}): Observable<any> {
    return Observable.of(this.getMockResponse(url));
  }
}





// WEBPACK FOOTER //
// ./src/app/core/mock-base.service.ts